'use client';

import React, { useState } from 'react';
import Header from '@/components/Header';
import GuestTrips from './components/GuestTrips';
import GuestWishlist from './components/GuestWishlist';
import GuestReviews from './components/GuestReviews';
import GuestPayments from './components/GuestPayments';
import GuestProfile from './components/GuestProfile';

const navItems = [
  { id: 'trips', label: 'My Trips', icon: '✈️' },
  { id: 'wishlist', label: 'Wishlist', icon: '❤️' },
  { id: 'reviews', label: 'Reviews', icon: '⭐' },
  { id: 'payments', label: 'Payments', icon: '💳' },
  { id: 'profile', label: 'Profile', icon: '👤' },
];

export default function GuestDashboardPage() {
  const [activeSection, setActiveSection] = useState('trips');

  const renderSection = () => {
    switch (activeSection) {
      case 'trips': return <GuestTrips />;
      case 'wishlist': return <GuestWishlist />;
      case 'reviews': return <GuestReviews />;
      case 'payments': return <GuestPayments />;
      case 'profile': return <GuestProfile />;
      default: return <GuestTrips />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Dashboard Header */}
          <div className="mb-8 flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                My Dashboard
              </h1>
              <p className="text-gray-500 mt-1 text-sm">Welcome back, Sarah — manage your trips and account</p>
            </div>
            <div className="hidden md:flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-[#4088C6]/10 flex items-center justify-center text-[#4088C6] font-bold text-lg">
                S
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900">Sarah Nakato</p>
                <p className="text-xs text-gray-500">Member since 2022</p>
              </div>
            </div>
          </div>

          {/* Tab Navigation */}
          <div className="flex gap-1 bg-white rounded-2xl p-1.5 shadow-sm border border-gray-100 mb-8 overflow-x-auto">
            {navItems?.map((item) => (
              <button
                key={item?.id}
                onClick={() => setActiveSection(item?.id)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap transition-all duration-200 flex-1 justify-center ${
                  activeSection === item?.id
                    ? 'bg-[#4088C6] text-white shadow-sm'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <span>{item?.icon}</span>
                <span>{item?.label}</span>
              </button>
            ))}
          </div>

          {/* Section Content */}
          <div>{renderSection()}</div>
        </div>
      </div>
    </div>
  );
}
